export const formValidation = function () {
    async function validateForm (form: HTMLFormElement) {
        const isValid = await form.checkValidity()

        if (!isValid) {
            form.reportValidity()
            return false
        }

        return true
    }

    async function validateField (field: HTMLInputElement) {
        if (!field.checkValidity()) {
            field.reportValidity()
            return false
        }

        return true
    }

    return {
        validateForm,
        validateField
    }
}
